module.exports = "/_next/static/images/top-c1e841c6792e2952367f1373235eab48.jpg";